import { AlpineComponent } from "alpinejs";
import {
  default as AjaxList,
  ListXDataContext as AjaxListXDataContext,
  ListOptions as AjaxListOptions
} from '../../../components/AjaxList/Classes/List';
import ListItem from "../../../components/AjaxList/Classes/Item";
import { IHistoryStateProps } from "../../../utils/historyState";

export type ListComponent = AlpineComponent<AjaxListXDataContext<ListItem> & {
  filterItems: () => void;
  resetFilter: () => void;
}>;

export type ListOptions = AjaxListOptions & IHistoryStateProps;

const List = (options: ListOptions, filterData = {}):ListComponent => {
  return {
    ...AjaxList(options, filterData),

    filterItems() {
      this.filteredItems = this.items;

      if (this.filter && this.filter.data) {
        this.filteredItems = this.filteredItems.filter((item) => {
          // for each filter property
          for (const property in this.filter!.data) {
            let filterPropertyValue = this.filter!.data[property];
            let itemPropertyValue = item[property];

            // if filter data property is empty, skip it
            if ((!filterPropertyValue) ||
              (Array.isArray(filterPropertyValue) && filterPropertyValue.length === 0)
            ) {
              continue;
            }

            // Date start
            if (property == 'date_start') {
              if (itemPropertyValue) {
                const [day, month, year] = filterPropertyValue.split('.');
                const filterDate = new Date(`${year}-${month}-${day}`).getTime();

                const [itemDay, itemMonth, itemYear] = itemPropertyValue.split('.');
                const itemDate = new Date(`${itemYear}-${itemMonth}-${itemDay}`).getTime();

                if (itemDate < filterDate) {
                  return false;
                }
              }

              continue;
            }

            // Date end
            if (property == 'date_end') {
              const [day, month, year] = filterPropertyValue.split('.');
              const filterDate = new Date(`${year}-${month}-${day}`).getTime();
              let itemDate = null;

              if (item['date_end'] && item['date_end'] >= item['date_start']) {
                const [itemDay, itemMonth, itemYear] = item['date_end'].split('.');
                itemDate = new Date(`${itemYear}-${itemMonth}-${itemDay}`).getTime();
              } else {
                const [itemDay, itemMonth, itemYear] = item['date_start'].split('.');
                itemDate = new Date(`${itemYear}-${itemMonth}-${itemDay}`).getTime();
              }

              if (itemDate > filterDate) {
                return false;
              }

              continue;
            }

            if (property === 'query') {
              let filterPropertyValueEscaped = filterPropertyValue.trim().replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
              let isMatch = ['title', 'description', 'states', 'postal-code', 'location'].some(itemProperty => item[itemProperty] && RegExp(filterPropertyValueEscaped, "i").test(item[itemProperty].toString()))
              if (!isMatch) {
                return false;
              }

              continue;
            }

            // if item property has objects with uids, get flat list of uids
            if (Array.isArray(itemPropertyValue) && itemPropertyValue.length > 0 && itemPropertyValue[0].uid) {
              itemPropertyValue = itemPropertyValue.map((item: {uid: any}) => item.uid);
            }

            if (Array.isArray(filterPropertyValue) && Array.isArray(itemPropertyValue)) {
              // if filter data property and item property are both arrays, check if at least one item property is in filter data property
              if (!(itemPropertyValue as Array<any>).some((value) => (filterPropertyValue as Array<any>).includes(value))) {
                return false;
              }
            } else if (Array.isArray(filterPropertyValue)) {
              // if filter data property is an array and item property is not, check if item property is in filter data property
              if (!filterPropertyValue.includes(itemPropertyValue)) {
                return false;
              }
            } else if (Array.isArray(itemPropertyValue)) {
              // if item property is an array and filter data property is not, check if filter data property is in item property
              if (!(itemPropertyValue as Array<any>).includes(Number(filterPropertyValue))) {
                return false;
              }
            } else if (filterPropertyValue !== itemPropertyValue) {
              // if filter data property and item property are not arrays, check if they are equal
              return false;
            }
          }

          return true;
        });
      }

      if (this.pagination) {
        this.pagination.setTotalItems(this.filteredItems.length);
        this.pagination.goToPage(1);
      }
    },

    resetFilter() {
      // Remove all parameters from url
      const url = new URL(window.location.href);
      url.search = '';
      window.location.href = url.toString();
    }
  }
}

export default List;
